import { Button, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Action } from "../util/func";

export function OnBlurTextField({ label, value, onBlur, disabled }: { label?: string; value: string; onBlur?: Action<string>; disabled?: boolean }) {
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    if (localValue !== value) {
      setLocalValue(value);
    }
  }, [value]);
  return (
    <TextField
      fullWidth
      margin="dense"
      variant="outlined"
      label={label}
      value={localValue}
      onBlur={() => {
        if (onBlur && value !== localValue) {
          onBlur(localValue);
        }
      }}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
      disabled={disabled}
    />
  );
}

export function OnChangeTextField({ label, type, name, autoComplete, value, onChange, disabled, error }: { label?: string; type?: string; name?: string; autoComplete?: string; value: string; onChange?: Action<string>; disabled?: boolean; error?: string }) {
  return (
    <TextField
      fullWidth
      margin="dense"
      variant="outlined"
      autoComplete={autoComplete ?? "off"}
      type={type}
      name={name}
      label={label}
      value={value}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      disabled={disabled}
      error={error !== undefined}
      helperText={error}
    />
  );
}
